/* eslint-disable react/no-unescaped-entities */
import api from 'api';
import { googleAdsSend } from 'functions';
import { useEffect, useRef, useState } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import Requesting from 'Requesting';
import { useNavigate } from 'react-router-dom';
import { pixelNative, pixelTikTok, googleAnalyticsSend } from 'functions';

const ModalPix = ({
  paymentStatus,
  setPaymentStatus,
  setShowModal,
  uuidOffer,
  offer,
  selectedBumps,
  selectedPlan,
  pixels,
  orderBumpsFinal,
  paymentMethod,
  googlePixels,
  googleAds,
  coupon,
}) => {
  const [requesting, setRequesting] = useState(true);
  const [error, setError] = useState(null);
  const [pixData, setPixData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [price, setPrice] = useState(null);
  const [togglePix, setTogglePix] = useState(false);
  const navigate = useNavigate();
  const ref = useRef(null);

  useEffect(() => {
    let orderBumps = [];

    selectedBumps.forEach((item) => {
      orderBumps.push(item.uuid);
    });
    let finalPrice = offer.prices.pix;
    finalPrice += selectedBumps.reduce((acc, item) => {
      acc += item.prices.pix;
      return acc;
    }, 0);

    setPrice(finalPrice);

    let body = {
      offer_id: uuidOffer,
      order_bumps: orderBumps,
      coupon: coupon?.coupon,
    };
    let endpoint = '/sales/pix';
    if (!pixData) {
      if (offer.payment.type === 'subscription') {
        endpoint = '/sales/subscriptions';
        body['plan_id'] = selectedPlan.uuid;
        body['payment_method'] = 'pix';
      }
      api
        .post(endpoint, body)
        .then((r) => {
          setError(null);
          setPixData(r.data);
          if (googlePixels.length > 0) {
            googlePixels.forEach(() => {
              googleAnalyticsSend('purchase', {
                currency: 'BRL',
                value: offer.price,
                transaction_id: r.data.sale_id,
                items: [{ item_name: offer.product.name }],
              });
            });
          }
          if (googleAds.length > 0) {
            googleAds.forEach((item) => {
              if (item.settings.purchase)
                googleAdsSend({
                  currency: 'BRL',
                  value: offer.price,
                  transaction_id: r.data.sale_id,
                  send_to: `${item.settings.pixel_id}/${item.settings.purchase_label}`,
                });
            });
          }
          pixels.forEach((item) => {
            if (item.generated_pix) {
              pixelNative('Purchase', {
                value: offer.price,
                currency: 'BRL',
                content_type: 'product',
                content_ids: [offer.uuid],
                num_items: 1,
              });

              pixelTikTok('CompletePayment', {
                value: offer.price,
                currency: 'BRL',
                content_type: 'product',
                content_id: offer.uuid,
                quantity: 1,
              });
            }
          });
        })
        .catch((e) => {
          setError(e.response.data.message);
        })
        .finally(() => {
          setRequesting(false);
        });
    }
  }, []);

  useEffect(() => {
    let intervalId = null;

    if (pixData) {
      intervalId = setInterval(() => {
        checkPixStatus();
      }, 15 * 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [pixData]);

  const checkPixStatus = () => {
    if (pixData && pixData.sale_id) {
      let fields = {
        sale_id: pixData.sale_id,
      };

      api.post('/sales/pix/status', fields).then((r) => {
        if (r.data.status === 'expired') {
          setPixData(null);
          setShowModal(false);
        }
        if (r.data.status === 'confirmed') {
          pixels.forEach((item) => {
            if (item.paid_pix) {
              pixelNative('Purchase', {
                value: offer.price,
                currency: 'BRL',
                content_type: 'product',
                content_ids: [offer.uuid],
                num_items: 1,
              });
              pixelTikTok('CompletePayment', {
                value: offer.price,
                currency: 'BRL',
                content_type: 'product',
                content_id: offer.uuid,
                quantity: 1,
              });
            }
          });
          setPaymentStatus(true);
          redirect();
        }
      });
    }
  };

  const redirect = async () => {
    setTimeout(() => {
      if (pixData.upsell_url) {
        window.location = pixData.upsell_url;
      } else {
        navigate(`/compra-realizada/${pixData.sale_id}`);
      }
    }, 5000);
  };

  const copyToClipboard = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(pixData.pix_code);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <>
      <Modal.Header closeButton={!paymentStatus}>
        <div></div>
      </Modal.Header>
      <Modal.Body>
        {requesting && <Requesting />}
        {!requesting &&
          (error === null ? (
            <Row>
              <Col md={12}>
                <div className='modal-pix'>
                  <h3>Siga os passos abaixo para realizar o pagamento:</h3>
                  <div className='content'>
                    <div className='summary'>
                      <ol>
                        <li>
                          <div className='number'>1</div>
                          <span>
                            Copie o código <b>PIX</b>
                          </span>
                        </li>
                        <div className='hide-desk'>
                          <textarea
                            id='pix-code'
                            className='form-control pix-code'
                            defaultValue={pixData.pix_code}
                            onClick={copyToClipboard}
                            ref={ref}
                            readOnly
                          />
                          <div className='list-buttons'>
                            <Button
                              size='sm'
                              onClick={copyToClipboard}
                              variant={!copied ? 'primary' : 'success'}
                            >
                              {!copied ? (
                                <>
                                  <i className='la la-copy mr-2' />{' '}
                                  <span>Copiar código PIX</span>
                                </>
                              ) : (
                                <span>Copiado! :)</span>
                              )}
                            </Button>
                            <Button
                              size='sm'
                              variant={'primary'}
                              className='outline'
                              onClick={() => setTogglePix(!togglePix)}
                            >
                              <i className='las la-qrcode mr-2' />
                              <span>Ver QRCode</span>
                            </Button>
                          </div>
                          {togglePix && (
                            <div className='pix-photo'>
                              <img
                                src={
                                  'data:image/png;base64, ' +
                                  pixData.base64_qrcode
                                }
                                className='img-fluid'
                                style={{ border: '1px solid #eee' }}
                              />
                            </div>
                          )}
                        </div>
                        <li>
                          <div className='number'>2</div>
                          <span>Abra o aplicativo do seu banco favorito</span>
                        </li>
                        <li>
                          <div className='number'>3</div>
                          <span>
                            Na seção de PIX, selecione a opção "
                            <b>Pix Copia e Cola</b>"
                          </span>
                        </li>
                        <li>
                          <div className='number'>4</div>
                          <span>Cole o código</span>
                        </li>
                        <li>
                          <div className='number'>5</div>
                          <span>Confirme o pagamento</span>
                        </li>
                      </ol>
                    </div>
                    <div className='qr-code'>
                      {pixData && (
                        <>
                          <div className='pix-data'>
                            <Button
                              size='sm'
                              onClick={copyToClipboard}
                              variant={!copied ? 'primary' : 'success'}
                            >
                              {!copied ? (
                                <>
                                  <i className='la la-copy mr-2' /> Copiar
                                  código PIX
                                </>
                              ) : (
                                'Copiado! :)'
                              )}
                            </Button>
                            <img
                              src={
                                'data:image/png;base64, ' +
                                pixData.base64_qrcode
                              }
                              className='img-fluid'
                              style={{ border: '1px solid #eee' }}
                            />
                            {/*   <textarea
                            id='pix-code'
                            className='form-control pix-code'
                            defaultValue={pixData.pix_code}
                            onClick={copyToClipboard}
                            ref={ref}
                            readOnly
                          /> */}
                          </div>
                        </>
                      )}

                      {!paymentStatus ? (
                        <div className='waiting-payment'>
                          <i className='la la-circle-notch la-spin mr-2' />
                          <span>Aguardando pagamento...</span>
                        </div>
                      ) : (
                        <div className='payment-confirmed'>
                          <i className='la la-check mr-2' />
                          <span>Pagamento confirmado!</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            <>
              Erro ao gerar pix.
              <br />
              <b>{error}</b>
            </>
          ))}
      </Modal.Body>
    </>
  );
};

export default ModalPix;
